/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VeranstaltungenMandantOptions { 
    fb_admin_zugriff?: boolean;
    auswahl_nur_diensthabende?: boolean;
    funkprotokoll_rollen_ids?: Array<string>;
}

